<!--
 * @Description:
 * @Author: LXG
 * @Date: 2022-01-27
 * @Editors: LXG
 * @LastEditTime: 2022-01-27
-->
<template>
  <div class="background">
    <div class="header">
      <div class="header-wrap">
        <img
          src="@/assets/images/mobile/return.png"
          class="header-img"
          @click="gotoLogin"
        />
       <div class="flex-column flex-center">
          <img
          src="@/assets/images/mobile/user_1.png"
          class="header-img"
          @click="toPage('/userCenter')"
        />
        <span style="color:#009ffe;font-size:0.75rem">用户中心</span>
       </div>
      </div>
    </div>
    <img class="img1" src="../../assets/images/mobile/newbj.png" />
    <div class="policyCont">
      <div class="policyleft">
        <img src="~@/assets/images/mobile/gzdt.png" alt="" />
      </div>
      <div class="policyright">
        <el-carousel height="5vh" direction="vertical" :interval="2000" indicator-position="none">
          <el-carousel-item v-for="item in ggList" :key="item">
            <p class="medium"   @click="tonewpage(item.id)">{{ item.name }}</p>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="content">
      <img class="whiteImg" src="../../assets/images/whiteImg.png" />
      <div class="suqiu-content">
        <div v-for="(item, index) in imgmetaList" :key="index">
          <img :src="item" alt="" @click="goToDetail(index)" />
        </div>
      </div>
      <div class="content-text">
        <div><p style="font-size: 16px">信阳市人民政府</p></div>
      </div>
    </div>
    <div v-if="showErweima" class="blur-bg">
      <div class="qrcode">
        <img class="qrcode-content" src="@/assets/temp/qrcode-bg.png" />
        <div class="qrcode-title">{{ title }}</div>
        <div class="qrcode-code" ref="receiptCode">
          <span class="qrcode-company">企业专属码</span>
        </div>
        <div @click="close">
          <img class="qrcode-close" src="@/assets/temp/qrcode-close.png" />
        </div>
      </div>
    </div>
    <!-- <img
        class="img2"
        src="../../assets/images/login.png"
    /> -->
    <!--
    <div
        class="login-content"
    >
        <div class="login-right">
           <span v-for="(item,index) in suqiuList" :key="index" class="item" @click="goToDetail(index)">{{item.value}}</span>
            <span class="item">我要咨询</span>
           <span class="item">我要投诉</span>
           <span class="item">我要举报</span>
           <span class="item">我要提诉求</span>
        </div>
      <div v-if="showErweima" style="margin-left: 2.5rem">
        <img src="@/assets/temp/erweima.png" style="width: 20rem;margin: 0 auto">
      </div>
    </div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import variableStyle from "@/styles/variable.scss";

export default {
  name: "Login",
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
    classOption() {
      return {
        step: 0.1, //数值越大速度滚动越快
        limitMoveNum: 5, //开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, //单步运动停止的时间(默认值1000ms)
      };
    },
  },
  data() {
    return {
      title: "",
      showErweima: false, // 显示二维码
      suqiuList: [
        { value: "我要咨询" },
        { value: "我要投诉" },
        { value: "我要举报" },
        { value: "我要提诉求" },
        { value: "我的二维码" },
      ],
      variableStyle: variableStyle,
      /* 切换 */
      activeType: "1",
      codeUrl: "", // 手机号登录时的图形验证码
      isCodeLogin: false, // 个人账号时 是否扫码登录,true则显示二维码或小程序码false
      isShowWxQrCode: true, // true则显示小程序码 false则显示二维码，上线后应该不要二维码了
      // 二维码登录的
      qrCodeUrl: "", // 二维码URL
      qrCodeStatus: "", // 已生成 generated 已扫描 Scanned  已登录 Signed  已作废 invalid
      qrKey: "", // 用这个key来轮询
      // 小程序码登录
      wxQrCodeUrl: "",

      loginForm: {
        phone: "13798580884",
        code: "654321",
        uuid: "", // 图形验证码UUID
        captchaCode: "", // 图形验证码
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
        phone: [
          { required: true, trigger: "blur", message: "请输入您的手机号码" },
        ],
        captchaCode: [
          { required: true, trigger: "blur", message: "请输入图形验证码" },
        ],
        code: [
          { required: true, trigger: "blur", message: "请输入短信验证码" },
        ],
      },
      loading: false,
      enterpriseList: [], // 是否有多家企业
      dialogVisible: false, // 弹窗选择哪一家企业来登录
      roleDialogLoading: false, // 多角色弹窗loading状态位
      // 短信验证码
      msgCodeInfo: {
        timer: null, // 计时器
        second: 60, // 计时时间
      },
      qrLoginInfo: {}, // 扫码登录返回的信息
      imgmetaList: [
        require("@/assets/images/mobile/sqmeta1.png"),
        require("@/assets/images/mobile/sqmeta2_1.png"),
        require("@/assets/images/mobile/sqmeta3_1.png"),
        require("@/assets/images/mobile/sqmeta4_1.png"),
        require("@/assets/images/mobile/sqmeta5.jpg"),
        require("@/assets/images/mobile/sqmeta6.png"),
        require("@/assets/images/mobile/sqmeta7_1.png"),
        require("@/assets/images/mobile/sqmeta8.png"),
        require("@/assets/images/mobile/sqmeta9.png"),
      ],
      ggList: [],
    };
  },
  methods: {
    toPage(url){
      this.$router.push(url);
    },
    gotoLogin() {
      console.log("退出登录");
      this.$router.replace({
        path: "/loginMobile",
      });
    },
    goToDetail(index) {
      switch (index) {
        case 3:
          // window.open("http://www.xysrcw.com");
          this.$router.push({
            path: "/talentService",
          });
          break;
        case 4:
          // window.open("http://36.133.218.216:8000/#/policyLibrary");
          this.$router.push("/enjoyNoApply");
          break;
        case 5:
          // window.open(
          //   "http://111.7.74.60:8090/xyzjmh/epointzjcs/pages/default/index"
          // );
          this.$router.push("/intermediaryMarket");
          break;
        default:
          this.$router.push({
            path: "/suqiuContentMobile",
            query: {
              type: index,
            },
          });
          break;
      }
    },
    close() {
      this.showErweima = false;
    },

    getUserInfo() {
      this.$httpApi
        .get(
          "/dev-api/getInfo" +
            "?appid=afc903d9d5e449488a3cf9a00c3d1294&appkey=8cb4f61b-e89a-405b-acc8-4d992826c247",
          {}
        )
        .then((res) => {
          // console.log("信息getInfo: ", res);
          if (res.code === 200 && res.data) {
            let baseInfo = res.data.baseInfo;
            if (baseInfo != null) {
              this.$store.commit("updateAccountBaseInfo", baseInfo);
            }

            let userInfo = res.data.userInfo || {};
            /**
             * 20210506
             * 元林优化了 账号密码登录后这个接口返回的用户信息
             * 补了最关键的 userId用户ID 和 tyshxydm统一社会信用代码
             * 参考 扫码登录后整理的数据格式，这边也统一处理
             */
            userInfo.topbrass = res.data.topbrass || {};
            userInfo.userId = userInfo.topbrass.userId; // 用户ID
            userInfo.username = userInfo.loginId; // 用户账号(手机号码)
            userInfo.nickName = userInfo.name; // 用户昵称
            userInfo.sex = userInfo.topbrass.sex; // 性别
            userInfo.tyshxydm = userInfo.topbrass.tyshxydm; // 统一社会信用代码

            // console.log("信息userInfo", userInfo);
            // 判断是哪种类型账号 （公司账号信息必有社会信用代码，以此为判断条件）
            // if (userInfo.shxydm) {
            //   this.userType = 0;
            // } else {
            //   this.userType = 1;
            // }
            let mid = {
              icon: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
              userStatus: "已经绑定账号", // 用户是否绑定账号状态
              emailStatus: "未绑定邮箱", // 邮箱状态
              security: "1", // 安全等级 0 1 2
            };
            Object.assign(userInfo, mid);
            // userInfo.shxydm = baseInfo.shxydm;
            this.$store.commit("updateUserInfo", userInfo);
          }
        })
        .catch((err) => {});
    },
    getggList() {
      let url = "/dev-api/qymgg/queryGgSbj";
      this.$httpApi.post(url, {}).then((r) => {
        this.ggList = r.data;
      });
    },
    openGgxqNotice(e, val, type) {
      let item = JSON.parse(e.target.dataset.obj);
      let eid = item.id;
      let etype = item.type;

      let that = this;
      let { href } = that.$router.resolve({
        path: "/notice/detail/" + eid + "?detailType=" + etype,
      });
      window.open(href, "_blank");
    },
    tonewpage(id){
        this.$router.push({path:'/mobilepolicydetail',query:{id:id}})
    }
  },
  created() {
    this.getggList();
    this.title = this.userInfo.enterpriseInfo.enterprise;
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "@/styles/com/theme.scss";
.background {
  background-color: white;
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  .img1 {
    width: 100vw;
    height: 100vh;
    // z-index: 101;
    position: absolute;
  }
  .content {
    //    background-color: red;
    width: 100vw;
    height: 67vh;
    position: absolute;
    top: 33%;
  }
}

.header {
  z-index: 100;
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;

  .header-wrap {
    flex: 1;
    width: 100%;
    height: 100%;
    //background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;

    .header-img {
      width: 30px;
      height: 30px;
    }
  }
}

.whiteImg {
  width: 95vw;
  // height:100vh;
  height: 98%;
  position: absolute;
  // top: 5%;
  left: 2.5%;
}
.suqiu-content {
  width: 95vw;
  left: 2.5%;
  height: 60vh;
  position: absolute;
  // background-color:yellow;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  padding: 2%;
  cursor: pointer;
  div {
    width: 28vw;
    img {
      width: 100%;
    }
  }
}

.content-text {
  position: absolute;
  top: 87%;
  width: 100%;
  font-family: Microsoft YaHei;
  color: #666666;
  font-size: 10px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  div {
    text-align: left;
    display: inline-block;
  }
  // span{
  //     text-align: left;
  //     display: inline-block;
  // }
}

.blur-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);
}

.qrcode {
  position: absolute;
  width: 80vw;
  top: 20%;
  left: 10%;
  height: 60vh;
  justify-content: center;
  align-items: center;
  /* overflow: hidden; */
  text-align: center;
}

.qrcode-content {
  position: absolute;
  height: 45vh;
  overflow: hidden;
  width: 90%;
  left: 5%;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.qrcode-title {
  position: absolute;
  width: 100%;
  top: 2%;
  height: 26px;
  font-family: Microsoft YaHei;
  color: white;
  font-size: 16px;
  text-align: center;
}

.qrcode-code {
  background-color: white;
  position: absolute;
  width: 210px;
  top: 10%;
  left: 50%;
  height: 60%;
  transform: translateX(-50%);
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.qrcode-company {
  position: absolute;
  width: 100%;
  bottom: 2%;
  left: 0%;
  height: 26px;
  font-family: Microsoft YaHei;
  font-size: 14px;
  text-align: center;
}

.qrcode-close {
  position: absolute;
  width: 45px;
  height: 45px;
  bottom: 10%;
  left: 40%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
}

.login-container {
  width: 100%;
  height: 100vh;
  background: url("../../assets/images/login_banner.png") center / 100% 100%
    no-repeat;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  overflow: hidden;
}
.login-system-name {
  position: absolute;
  top: 10vh;
  left: 50%;
  height: 60px;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}

.wrap-thumbnail,
.login-content {
  position: absolute;
  top: 48%;
  z-index: 102;
  -webkit-transform: translateY(-30%);
  -moz-transform: translateY(-30%);
  -o-transform: translateY(-30%);
  -ms-transform: translateY(-30%);
  transform: translateY(-30%);
}
.wrap-thumbnail {
  right: 50%;
  height: 400px;

  img {
    height: 100%;
  }
  .thumbnail-content {
    position: absolute;
    top: -20px;
    right: 10%;
    width: max-content;
    color: #ffffff;
    font-weight: bold;
    background-color: #1292ff;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      display: block;
      border-top: 5px solid transparent;
      border-right: 8px solid #1292ff;
      border-bottom: 5px solid transparent;
      -webkit-transform: translate(-100%, -50%);
      -moz-transform: translate(-100%, -50%);
      -o-transform: translate(-100%, -50%);
      -ms-transform: translate(-100%, -50%);
      transform: translate(-100%, -50%);
    }
  }
}

// .login-content {
//     left: 50%;
// }

.form-content {
  width: 435px;
  height: 520px;
  padding: 40px 50px;
  /*/ / border: 1 px solid #333;*/
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 3px 15px rgba($color: rgb(0, 0, 0), $alpha: 0.2);
  position: relative;

  // span {
  //   font-size: 16px;
  //   font-weight: 600;
  // }

  .el-form {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;

    .el-form-item {
      width: 100%;

      .el-form-item__content {
        height: 70px;
      }
    }
    .code-box {
      /*/ / background: red;*/
      width: 100%;

      .el-form-item__content {
        width: 100%;
        height: 100%;

        .login-code-ipt {
        }
        .login-code-img {
          width: 100px;
          height: 42px;
          cursor: pointer;
        }
      }
      .login-code-btn {
        margin-left: 4px;
      }
    }
  }
  .el-btn-ctr,
  .to-login {
    width: 100%;
    padding: 0 40px;
    margin-top: 10px;
  }

  .el-button {
    width: 100%;
  }

  .to-login {
    margin-top: 10px;
    position: relative;

    a {
      position: absolute;
      right: 40px;
    }
  }
  .btn-btm {
    width: 64px;
    height: 21px;
    margin-top: 20px;
    margin-right: 20px;
    font-size: 16px;
    text-align: left;

    a {
      color: #999999;
    }
  }

  .code-login-img {
    position: absolute;
    right: 1px;
    bottom: 1px;
    width: 60px;
    height: 60px;
    .code-img {
      width: 100%;
      height: 100%;
    }
  }
  .code-login {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    // height: 100%;
    text-align: center;
    .qr-code-box {
      width: 200px;
      height: 200px;
      margin-bottom: 20px;
      position: relative;
      .qr-code-img {
        width: 100%;
        height: 100%;
        background: #efefef;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .invalid-mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba($color: #fff, $alpha: 0.8);
        color: #000;
        font-size: 15px;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .shuaxin {
          width: 62px;
          height: 35px;
          line-height: 35px;
          border-radius: 50px;
          background-color: #383d42;
          color: #fff !important;
          margin-top: 16px;
        }
        .tip-img {
          width: 34px;
          height: 34px;
        }
        .tip-success {
          color: #000;
          font-size: 12px;
          margin-top: 24px;
          margin-bottom: 10px;
        }
        .tip-info {
          color: #000;
          font-size: 12px;
          font-weight: 700;
        }
      }
    }
    .tip-top {
      font-size: 14px;
      color: #222;
    }
    .tip-bottom {
      font-size: 12px;
      color: #555;
    }
    .tip-red {
      color: #f00;
    }
  }
}
.form-title {
  width: 100%;
  text-align: center;
  color: $col-theme;
  letter-spacing: 10px;
}
.input-login {
  width: 100%;
  min-height: 200px;

  .login-button {
    width: 100%;
    height: 50px;
    font-family: Microsoft YaHei;
    color: #ffffff;
    font-size: 16px;
    background-color: $col-theme;
    // margin-top: 30px;
  }
  .register-button {
    width: 100%;
    height: 48px;
    font-family: Microsoft YaHei;
    background-color: #fff !important;
    border: 1px solid #aaa !important;
    color: #666;
    font-size: 16px;
    margin-top: 10px;
    margin-left: 0;
  }
}
.p-content {
  padding: 30upx;

  .p-cell {
    background-color: #1995fe;
    color: #ffffff;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    cursor: pointer;

    .p-position {
      font-size: 13px;
    }
  }
}
@media screen and (min-width: 1200px) {
  .wrap-thumbnail {
    right: 55%;
  }
  .login-content {
    // left:28.5%;
    // z-index:102;
  }
}
.linkList {
  width: 115px;
  margin-top: 30px;
  text-align: center;
  div {
    margin: 10px auto;
    color: #e6503b;
  }
}
.el-form-item {
  margin-bottom: 30px;
}
.imgLink {
  width: 40px;
  height: 40px;
  background-color: red;
  background: url("../../assets/images/henan.png") center / 100% 100% no-repeat;
}
.chooseLogin {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  font-size: 20px;
  .light {
    color: #1292ff;
  }
}
.login-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background-color: white;
  width: 95vm;
  border-radius: 20px;

  .item {
    height: 30px;
    margin-top: 5px;
  }
}
.policyCont {
  position: absolute;
  width: 95vw;
  height: 5vh;
  top: 27%;
  left: 2.5%;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  .policyleft {
    width: 30%;
    height: 100%;
    text-align: center;
    margin: 0 auto;
    img {
      height: 6vh;
    }
  }
  .policyright {
    width: 70%;
  }
}
.medium{
    height: 5vh;
    line-height: 5vh;
}
</style>
